import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';

import renderInputField from '../formFields/Input';
import { LOGIN_PATH } from '../../utils/constants';
import { validate, sanitazeMessage } from '../../utils/form';

class UpdatePasswordForm extends PureComponent {
  render() {
    const {
      handleSubmit,
      valid,
      submitting,
      submitError,
      success
    } = this.props;
    if (success) {
      return (
        <div className="confirmation-title">
          <p>Your password has been successfully updated.</p>
          <p>
            You can <Link to={LOGIN_PATH}>login</Link> using new one
          </p>
        </div>
      );
    }
    return (
      <div className="auth-form login-form">
        <div className="error-wrapper">
          {submitError && (
            <Alert color="danger">
              {sanitazeMessage(submitError.message) ||
                'The token has expired or not valid. Please try again reset password'}
            </Alert>
          )}
        </div>
        <div className="form-title">Enter a new password and confirmation</div>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="password"
                component={renderInputField}
                type="password"
                placeholder="New Password"
              />
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="confirmPassword"
                component={renderInputField}
                type="password"
                placeholder="Confirm Password"
              />
            </div>
          </div>
          <div className="block-centered">
            <button
              className="btn btn-primary account__btn account__btn--small"
              disabled={!valid || submitting}
              onClick={handleSubmit}
            >
              Update password
            </button>
          </div>
          <div className="full-width auth-link">
            Go to <Link to={LOGIN_PATH}>Login page</Link>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'UpdatePasswordForm',
  validate
})(UpdatePasswordForm);



// WEBPACK FOOTER //
// ./src/components/updatePassword/UpdatePasswordForm.js